import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useCurrentLanguage, getLocalizedPath } from 'utils/localizedRouting';

export type LocalizedLinkProps = LinkProps;

/**
 * A drop-in replacement for Link that automatically prefixes the 'to' target
 * with the active language code (e.g. to="/affiliate" -> to="/ru/affiliate").
 */
export const LocalizedLink: React.FC<LocalizedLinkProps> = ({ to, ...props }) => {
  const currentLang = useCurrentLanguage();

  const localizedTo = React.useMemo(() => {
    if (typeof to === 'string') {
      return getLocalizedPath(to, currentLang);
    }
    if (to && typeof to === 'object' && to.pathname) {
      return {
        ...to,
        pathname: getLocalizedPath(to.pathname, currentLang),
      };
    }
    return to;
  }, [to, currentLang]);

  return <Link to={localizedTo} {...props} />;
};

export default LocalizedLink;
